import { Outlet } from 'react-router';
import { PublicFooter } from './PublicFooter.js';
import { PublicHeader } from './PublicHeader.js';

/**
 * Shell for the whole `/` public tree (step 11 — CLAUDE.md's Public
 * listings site section). Header and footer live here rather than in
 * PublicHomepage, so the four compliance stub pages inherit the same chrome
 * for free — the reference screenshot's footer is site-wide chrome, not a
 * homepage-only element.
 *
 * Deliberately outside `<Refine>`/`<SessionProvider>`'s actual USE, not
 * their nesting — this tree stays mounted inside those providers
 * mechanically (App.tsx's `<Routes>` is one tree), the same way `/apply`
 * already is, but calls no Refine or session hook. See styles.css's
 * "Public listings site" section for the visual language this scopes.
 */
export function PublicLayout() {
  return (
    <div className="public">
      <PublicHeader />
      <main className="public__main">
        <Outlet />
      </main>
      <PublicFooter />
    </div>
  );
}
